import googleIcon from '../images/googleIcon.svg';
import hi from '../images/hi.png';
import david from '../images/david_half.png';
import warning from '../images/warning.png';
import SpeechBubble from './speech_bubble.png';
import scott from '../images/scott.png';

export default { hi, david, warning, SpeechBubble, scott };
